import { render, staticRenderFns } from "./WareMaterials.vue?vue&type=template&id=0995dd47&scoped=true"
import script from "./WareMaterials.vue?vue&type=script&lang=js"
export * from "./WareMaterials.vue?vue&type=script&lang=js"
import style0 from "./WareMaterials.vue?vue&type=style&index=0&id=0995dd47&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0995dd47",
  null
  
)

export default component.exports